<label class="standalone-searchbox">
  <input
    #searchInput
    [placeholder]="
      'flu.wholesaler-pharmacy.popup.search-placeholder' | cxTranslate
    "
    (input)="search(searchInput.value)" />
  <button class="search-icon">
    <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
  </button>
</label>
